var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBeamrank1Selected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13,21 C13,20.4477153 12.5522847,20 12,20 C11.4477153,20 11,20.4477153 11,21 C11,21.1841927 11,22.1841927 11,24 L13,24 C13,22.1839972 13,21.1839972 13,21 Z",
    transform: "matrix(1 0 0 -1 0 44)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23,11 C23,10.4477153 22.5522847,10 22,10 C21.4477153,10 21,10.4477153 21,11 C21,11.1841927 21,12.1841927 21,14 L23,14 C23,12.1839972 23,11.1839972 23,11 Z",
    transform: "matrix(0 -1 -1 0 34 34)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3,11 C3,10.4477153 2.55228475,10 2,10 C1.44771525,10 1,10.4477153 1,11 C1,11.1841927 1,12.1841927 1,14 L3,14 C3,12.1839972 3,11.1839972 3,11 Z",
    transform: "rotate(-90 2 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13,1 C13,0.44771525 12.5522847,0 12,0 C11.4477153,0 11,0.44771525 11,1 C11,1.18419267 11,2.18419267 11,4 L13,4 C13,2.18399716 13,1.18399716 13,1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M5,8 L0,8 L0,6.60683188 L1.59552846,6.60683188 L1.59552846,2.38981916 L0,2.38981916 L0,1.0877428 C0.233739837,1.0877428 0.465785908,1.07166778 0.696138211,1.03951775 C0.926490515,1.00736772 1.11111111,0.95557044 1.25,0.884125921 C1.41260163,0.798392498 1.53878726,0.683188212 1.62855691,0.538513061 C1.71832656,0.39383791 1.76998645,0.214333557 1.78353659,0 L3.44004065,0 L3.44004065,6.60683188 L5,6.60683188 L5,8 Z",
    transform: "translate(10 8)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeamrank1Selected);
export default __webpack_public_path__ + "static/media/icon_beamrank_1_selected.55e5a6dee1370edfc874ea0b42299573.svg";
export { ForwardRef as ReactComponent };